import {
  SurveyModel,
  PageModel,
  Serializer,
} from 'survey-core';
import React from 'react';
import { registerCustomReactQuestion } from './register-react-custom-page';

export const IS_CUSTOM_PAGE = 'isCustomPage';

export const splitPascalCase = (input: string): string => {
  return input.replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camelCase
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // Add space between acronyms and words
    .trim();
};

interface DisplayCustomPageProps<TComponentProps = any> {
  survey: SurveyModel;
  component: React.ComponentType<TComponentProps>;
  getProps: () => TComponentProps;
  withoutFrame?: boolean;
}

export function displayCustomPage<TComponentProps> ({
  survey,
  component,
  withoutFrame = false,
  getProps,
}: DisplayCustomPageProps<TComponentProps>): void {
  const questionType = component.name;

  // Register the question type
  registerCustomReactQuestion<TComponentProps>({
    component,
    getProps,
    questionType,
  });
  const page = new PageModel(questionType);

  // If displayName is empty string, don't show any title
  if ((component as any).displayName === '') {
    page.title = '';
  } else {
    page.title = splitPascalCase((component as any).displayName || component.name);
  }

  const question = Serializer.createClass(questionType);
  if (!question) {
    console.error('Failed to add question');
    return;
  }
  page.setPropertyValue(IS_CUSTOM_PAGE, true);
  page.addElement(question);
  survey.addPage(page, survey.currentPageNo + 1);
  survey.currentPage = page;

  if (withoutFrame) {
    survey.onUpdateQuestionCssClasses.add((_, options) => {
      if (options.question.getType() === questionType) {
        options.question.cssClasses.withFrame += ' no-survey-frame';
      }
    });
  }
};
